import { awaitDataServiceFetcher } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/DataServiceFetchers';
import { SuccessCallback } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { IRecurringOrderRepository } from '../entities/IRecurringOrderRepository';
import { StandingOrder, SweepOrder, StandingOrderDetails, SweepOrderDetails } from '../entities';
import {
  standingOrdersDTOToStandingOrdersAdapter,
  sweepOrdersDTOToSweepOrdersAdapter,
  standingOrderDetailsDTOToStandingOrderDetailsAdapter,
  sweepOrderDetailsDTOToSweepOrderDetailsAdapter,
  standingOrdersCancelDTOToStandingOrdersCancelAdapter,
  sweepOrdersCancelDTOToSweepOrdersCancelAdapter,
} from './';

class RecurringOrderRepositoryImpl implements IRecurringOrderRepository {
  constructor() {
    this.GetStandingOrders = this.GetStandingOrders.bind(this);
    this.GetSweepOrders = this.GetSweepOrders.bind(this);
    this.GetStandingOrderDetails = this.GetStandingOrderDetails.bind(this);
    this.GetSweepOrderDetails = this.GetSweepOrderDetails.bind(this);
    this.CancelStandingOrder = this.CancelStandingOrder.bind(this);
    this.CancelSweepOrder = this.CancelSweepOrder.bind(this);
  }

  GetStandingOrders(): Promise<StandingOrder[]> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'GET',
        url: '/secure-web/api/private/orders/standing',
        dataAdapter: standingOrdersDTOToStandingOrdersAdapter,
      },
    });
  }

  GetSweepOrders(): Promise<SweepOrder[]> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'GET',
        url: '/secure-web/api/private/orders/sweep',
        dataAdapter: sweepOrdersDTOToSweepOrdersAdapter,
      },
    });
  }

  GetStandingOrderDetails(id: number): Promise<StandingOrderDetails> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'GET',
        url: `/secure-web/api/private/orders/standing/${id}`,
        dataAdapter: standingOrderDetailsDTOToStandingOrderDetailsAdapter,
      },
    });
  }

  GetSweepOrderDetails(id: number): Promise<SweepOrderDetails> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'GET',
        url: `/secure-web/api/private/orders/sweep/${id}`,
        dataAdapter: sweepOrderDetailsDTOToSweepOrderDetailsAdapter,
      },
    });
  }

  CancelStandingOrder(id: number, successCallback: SuccessCallback): Promise<{}> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'POST',
        url: `/secure-web/api/private/orders/standing/cancel`,
        data: { id },
        dataAdapter: standingOrdersCancelDTOToStandingOrdersCancelAdapter,
        nextCallback: successCallback,
      },
    });
  }

  CancelSweepOrder(id: number, successCallback: SuccessCallback): Promise<{}> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'POST',
        url: `/secure-web/api/private/orders/sweep/cancel`,
        data: { id },
        dataAdapter: sweepOrdersCancelDTOToSweepOrdersCancelAdapter,
        nextCallback: successCallback,
      },
    });
  }
}

export { RecurringOrderRepositoryImpl };
